
import {
  defineComponent, ref, onMounted, inject, watch,
} from '@vue/composition-api';
import { IPackageProperties } from '~/types/fightcamp';
import PdpSectionHeader from '~/components/v2/pdps/PdpSectionHeader.vue';
import { PACKAGE_DATA } from '~/constants/storyblok';
import PackageBuilderCard from './PackageBuilderCard.vue';
import MembershipInfo from './MembershipInfo.vue';

export default defineComponent({
  name: 'PackageStep',
  components: {
    PdpSectionHeader,
    PackageBuilderCard,
    MembershipInfo,
  },
  setup() {
    // @ts-ignore
    const { $store, $analytics } = useNuxtApp();
    const pkgData = inject(PACKAGE_DATA) as () => IPackageProperties[];
    // TODO change solution to not have to hardcode the index for 2 person package & check store first if selected
    const pkgIdSelected = ref(pkgData.value?.[1]?.id);
    function performPackgeSelection() {
      // TODO look at store first instead
      const packageSelected = pkgData.value.find((pkg) => pkg.id === pkgIdSelected.value);

      $analytics.productViewed({
        ...packageSelected.value,
        pathId: '/shop/products/fightcamp',
      });

      $store.commit('SET_PACKAGE_BUILDER', { step: 'package', productData: packageSelected });
    }

    watch(pkgIdSelected, (newVal) => {
      if (newVal) {
        performPackgeSelection();
      }
    });

    onMounted(() => {
      performPackgeSelection();
    });

    return {
      pkgData,
      pkgIdSelected,
    };
  },
});
